import css from "./style.module.css";
import PageHead from "../../../Components/PageHead/PageHead";
import { Get } from "../../../Services/Server";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Url from "../../../Services/Url";
import DataTable from "../../../Components/DataTable/DataTable";
import Utils from "../../../Services/Utills";
import Time from "../../../Services/Time";


const Reader = (rec) => {
	const exp = rec;
	return [
		"₦" + exp.total,
		rec.jobNumber,
		exp.submittedBy,
		rec.location,
		Time.getDate(exp.submittedAt),
	];
};

const ExpensesList = ({ navoption }) => {
	const heading = ["Job Number", "Submitted By", "Location", "Submitted on"];
	const Navigate = useNavigate();

	const [pending, setPending] = useState({
		heading: ["Pending Payments", ...heading],
	});
	const [approved, setApproved] = useState({
		heading: ["Approved Payments", ...heading],
	});
	const [scheduled, setScheduled] = useState({
		heading: ["Scheduled Payments", ...heading],
	});
	const [disapproved, setDisapproved] = useState({
		heading: ["Disapproved Payments", ...heading],
	});

	const [view, setView] = useState("pending"); // Default view

	const flex = [20, 20, 20, 20, 20];

	const loadPending = (page) => {
		Get(Url.expenses.enterpriseTasksdto(false, page))
			.then((resp) => {
				setPending({ ...pending, data: resp });
			})
			.catch((err) => {
				console.log(err);
			});
	};

	const loadApproved = (page) => {
		Get(Url.expenses.enterpriseTasksdto(true, page))
			.then((resp) => {
				setApproved({ ...approved, data: resp });
			})
			.catch((err) => {
				console.log(err);
			});
	};

	const loadScheduled = (page) => {
		Get(Url.expenses.enterpriseCompleted(page))
			.then((resp) => {
				setScheduled({ ...scheduled, data: resp });
			})
			.catch((err) => {
				console.log(err);
			});
	};
	const loadDisapproved = (page) => {
		Get(Url.expenses.enterpriseDisapproved(page))
			.then((resp) => {
				setDisapproved({ ...disapproved, data: resp });
			})
			.catch((err) => {
				console.log(err);
			});
	};

	useEffect(() => {
		loadPending(0);
		loadApproved(0);
		loadScheduled(0);
		loadDisapproved(0);
	}, []);

	const onExpenseClick = (e) => {
		Navigate("" + e.expenseId);
	};

	const handlePagination = (page) => {
		if (view === "pending") loadPending(page);
		else if (view === "approved") loadApproved(page);
		else if (view === "scheduled") loadScheduled(page);
		else if (view === "disapproved") loadDisapproved(page);
	};

	const dropOptions = {
		onClick: (e) => {
			const op = e.find((o) => o.selected);
			if (!op) {
				setView("pending"); // Default to "Pending Expenses"
			} else {
				if (op.text === "Pending Payments") setView("pending");
				else if (op.text === "Approved Payments") setView("approved");
				else if (op.text === "Scheduled Payments") setView("scheduled");
				else if (op.text === "Disapproved Payments") setView("disapproved");
			}
		},
		list: [
			"Pending Payments",
			"Approved Payments",
			"Scheduled Payments",
			"Disapproved Payments",
		],
	};

	return (
		<div className={css.Page}>
			<PageHead
				navoption={navoption}
				dropOptions={dropOptions}
				filter={"Pending Payments"}
				title="Payments"
			></PageHead>
			<div>
				{view === "pending" && pending.data && (
					<DataTable
						handlePagination={handlePagination}
						reader={Reader}
						onClick={onExpenseClick}
						flex={flex}
					>
						{pending}
					</DataTable>
				)}
				{view === "approved" && approved.data && (
					<DataTable
						handlePagination={handlePagination}
						reader={Reader}
						onClick={onExpenseClick}
						flex={flex}
					>
						{approved}
					</DataTable>
				)}
				{view === "scheduled" && scheduled.data && (
					<DataTable
						handlePagination={handlePagination}
						reader={Reader}
						onClick={onExpenseClick}
						flex={flex}
					>
						{scheduled}
					</DataTable>
				)}
				{view === "disapproved" && disapproved.data && (
					<DataTable
						handlePagination={handlePagination}
						reader={Reader}
						onClick={onExpenseClick}
						flex={flex}
					>
						{disapproved}
					</DataTable>
				)}
			</div>
		</div>
	);
};

export default ExpensesList;
